module.exports = __webpack_public_path__ + "static/mabry-medium-pro-0a274aa8664e98aaa14cd86f85e36ec1.woff";